// extracted by mini-css-extract-plugin
module.exports = {"video":"SleepScreenVideoPreview_video__25Rqy"};